<template>
  <DialogoFormulario
    ref="dialog"
    title="Atualizar local de estoque"
    submit-text="Atualizar"
    :handler="handler"
  >
    <template v-slot="{ form, errors }">
      <v-text-field
        autofocus
        v-model="form.nome"
        label="Nome"
        :error-messages="errors.nome"
        outlined
      ></v-text-field>
    </template>
  </DialogoFormulario>
</template>

<script>
import DialogoFormulario from "@/components/dialogos/DialogoFormulario.vue";
import locacoesApi from "../../../services/locacoes";

export default {
  components: {
    DialogoFormulario
  },

  methods: {
    open(inicial) {
      this.$refs.dialog.open(inicial);
    },

    async handler(form) {
      const localEstoque = await locacoesApi.locais_de_estoque.atualizar(
        form.id,
        form
      );
      this.$emit("atualizado", localEstoque);
    }
  }
};
</script>
